import PropTypes from 'prop-types';
import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const savedUser = localStorage.getItem('user');
    const savedToken = localStorage.getItem('token');

    if (savedUser && savedUser !== 'undefined' && savedToken) {
      try {
        setUser(JSON.parse(savedUser));
        setToken(savedToken);
      } catch (e) {
        console.error('Failed to parse saved user:', e);
        localStorage.removeItem('user');
      }
    }

    setLoading(false);
  }, []);

  const setAndStoreUser = (newUser) => {
    if (newUser.profileImage) {
      if (newUser.profileImage.url) {
        newUser.profileImage = newUser.profileImage.url;
      }
    }

    setUser(newUser);
    localStorage.setItem('user', JSON.stringify(newUser));
  };

  const login = (userData, token) => {
    setUser(userData);
    setToken(token);
    localStorage.setItem('user', JSON.stringify(userData));
    localStorage.setItem('token', token);
  };

  const logout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem('user');
    localStorage.removeItem('token');
  };

  const provider_values = useMemo(() => {
    return {
      user,
      setUser: setAndStoreUser,
      token,
      login,
      logout,
      loading,
    };
    // The home link now depends on permissions too: see PermissionsContext.
  }, [user, setAndStoreUser, token, login, logout, loading]);

  return (
    <AuthContext.Provider value={provider_values}>
      {children}
    </AuthContext.Provider>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.node,
};

export const useAuth = () => useContext(AuthContext);
